import { z } from "zod"

export const UpdateAdapterSpeedRequest = z.object({ hostname: z.string(), adapterSpeedMbps: z.number().min(0) })
export type UpdateAdapterSpeedRequest = z.infer<typeof UpdateAdapterSpeedRequest>
